import React from "react";

interface ResponsiveContextType {
  isMobileView: boolean;
}

const ResponsiveContext = React.createContext<ResponsiveContextType>({ isMobileView: false });

function ResponsiveProvider({ children }) {
  const [isMobileView, setMobileView] = React.useState(false);

  React.useEffect(() => {
    const setResponsiveness = () => setMobileView(window.innerWidth < 900);

    setResponsiveness();

    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  return (
    <ResponsiveContext.Provider value={{ isMobileView }}>
      {children}
    </ResponsiveContext.Provider>
  );
}

export { ResponsiveContext, ResponsiveProvider };
